export default "__VITE_PUBLIC_ASSET__6f87bd52__"